import { ChangeDetectionStrategy, Component, inject, input, OnInit, signal } from '@angular/core';
import { CreateDamageReportService, FileWithMeta, UploadStatus, WithUploadStatus } from '../..';
import { CtrlModalsService } from '@co-3/ctrl-ui/modals';
import { createMessageFromRejectedFiles } from '../../../fns/create-message-from-rejected-files';
import { CtrlFileSelectDirective, RejectedFile } from '@co-3/ctrl-ui/forms';
import { FileAttachmentMetaModalComponent } from '../file-attachment-meta-modal/file-attachment-meta-modal.component';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';
import { Contract } from '@models/contract';
import { DamageReportFileAttachment } from '@models/damage-report';
import { AttachedFileListItemComponent } from '../attached-file-list-item/attached-file-list-item.component';

@Component({
    selector: 'app-attached-file-list',
    imports: [AttachedFileListItemComponent, CtrlFileSelectDirective, CtrlIconComponent],
    templateUrl: './attached-file-list.html',
    styleUrl: './attached-file-list.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AttachedFileList implements OnInit {
    private modalService = inject(CtrlModalsService);
    private createDamageReportService = inject(CreateDamageReportService);

    public damageReportId = input<number>();
    public initialDocuments = input<DamageReportFileAttachment[]>();
    public contract = input<Contract>();
    public insuranceTypeId = input<number>();

    protected documents = signal<DamageReportFileAttachment[]>([]);
    private files: WithUploadStatus<FileWithMeta>[] = [];

    public ngOnInit(): void {
        this.createDamageReportService.selectContract(this.contract());
        this.documents.set(this.initialDocuments());
    }

    public handleFilesSelected(selectedFiles: File[]): void {
        const files = selectedFiles.filter((file) => !this.documents().some((doc) => file.name === doc.url));
        if (files.length > 0) {
            this.openModals(files, 0);
        } else {
            alert('Ein Dokument mit diesem Namen wurde bereits hinzugefügt.');
        }
    }
    protected handleFilesRejected(rejectedFiles: RejectedFile[]): void {
        alert(createMessageFromRejectedFiles(rejectedFiles));
    }
    private openModals(files: File[], currentIndex: number): void {
        this.modalService
            .open(FileAttachmentMetaModalComponent, {
                file: { file: files[currentIndex] } as FileWithMeta,
                currentFileNo: currentIndex + 1,
                totalFileNo: files.length,
            })
            .subscribe((fwm) => {
                if (fwm) {
                    const fwmwus: WithUploadStatus<FileWithMeta> = {
                        ...fwm,
                        status: UploadStatus.READY,
                    };
                    this.files.push(fwmwus);
                }
                if (currentIndex + 1 < files.length) {
                    this.openModals(files, currentIndex + 1);
                } else {
                    this.createDamageReportService
                        .submitFilesOnly(this.damageReportId(), this.files)
                        .subscribe((uploadedFiles) => this.documents.update((values) => [...values, ...uploadedFiles]));
                }
            });
    }
}
